/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BenutzerIdentifier } from '../model/benutzerIdentifier';
// @ts-ignore
import { BenutzerSichtbarkeitRequest } from '../model/benutzerSichtbarkeitRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BenutzerEinstellungenAdminCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostBenutzerIncidentManagementSichtbarkeitAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/einstellungen/benutzer/v1/incidentmanagement/sichtbarkeit
     * @param benutzerSichtbarkeitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerIncidentManagementSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerIncidentManagementSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerIncidentManagementSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerIncidentManagementSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerSichtbarkeitRequest === null || benutzerSichtbarkeitRequest === undefined) {
            throw new Error('Required parameter benutzerSichtbarkeitRequest was null or undefined when calling postBenutzerIncidentManagementSichtbarkeitAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/einstellungen/benutzer/v1/incidentmanagement/sichtbarkeit`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerSichtbarkeitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTroubleTicketsSichtbarkeitAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/einstellungen/benutzer/v1/troubletickets/sichtbarkeit
     * @param benutzerSichtbarkeitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTroubleTicketsSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTroubleTicketsSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTroubleTicketsSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTroubleTicketsSichtbarkeitAdmin(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerSichtbarkeitRequest === null || benutzerSichtbarkeitRequest === undefined) {
            throw new Error('Required parameter benutzerSichtbarkeitRequest was null or undefined when calling postBenutzerTroubleTicketsSichtbarkeitAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/einstellungen/benutzer/v1/troubletickets/sichtbarkeit`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerSichtbarkeitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
